class AsyncLoader {
	constructor (container) {
		this.container = container
		this.isWaiting = false
		this.isLoadedAll = false
	}

	downloadAll (val) {
		this.isLoadedAll = val
	}

	addListener () {
		window.addEventListener('scroll', this.listenToScroll.bind(this))
	}

	async listenToScroll () {
		if (this.isWaiting) return false
		this.isWaiting = true
		const distanceBetweenStartPageAndContainer = this.container.getBoundingClientRect().top
		const containerHeight = this.container.clientHeight
		const pointOfScreenStartLoading = window.innerHeight

		if (distanceBetweenStartPageAndContainer + containerHeight < pointOfScreenStartLoading) {
			await this.loadData()
		}
		this.isWaiting = false
	}
}

export default AsyncLoader



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/AsyncLoader.js